<script setup lang="ts">
import { onMounted, ref } from 'vue'
import IconComponent from '../ui/common/IconComponent.vue';
import { useRouter } from 'vue-router';
import { api } from '../../api/Api';
import ReportViewer from './ReportViewer.vue'

defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const router = useRouter()

const reports = ref<any[]>([]);

const navigateTo = (path: string) => {
  router.push(path)
  emit('close')
}


const getReports = async () => {
  const response = await api.post("reports/get-my", {
  });
  if (response.success == true) {
    reports.value = response.data || [];
  }
}

onMounted(() => {
 getReports()
});

const showReport = ref(false);

const handleRowExpand = (row: any) => {
  console.log('Row expanded:', row);
};

const reportId = ref('')
const handleReportSelect = (id: any) => {
  reportId.value = id
  showReport.value = true
}


</script>

<template>
  <div 
    v-if="isOpen"
    class="fixed inset-0 bg-black bg-opacity-50 z-50"
    @click="$emit('close')"
  >
    <div 
      class="absolute right-0 top-0 bottom-0 w-96 bg-white dark:bg-black shadow-lg"
      @click.stop
    >
      <div class="p-4 border-b border-gray-100 dark:border-gray-800 flex justify-between items-center">
        <h2 class="text-lg font-semibold text-gray-800 dark:text-white">Reports</h2>
        <button 
          @click="$emit('close')"
          class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          ✕
        </button>
      </div>

      <div class="pb-0">
        <div class="quick-access-buttons">
          <button class="quick-access-btn" @click="navigateTo('/reports/profit-loss')">
            <IconComponent name="ChartSpline" />
            <span>Profit & Loss</span>
          </button>
          
          <button class="quick-access-btn" @click="navigateTo('/reports/balance-sheet')">
            <IconComponent name="ChartColumnStacked" />
            <span>Balance Sheet</span>
          </button>

          <button class="quick-access-btn" @click="navigateTo('/reports/trial-balance')">
            <IconComponent name="ChartBarStacked" />
            <span>Trial Balance</span>
          </button>
          
          <button class="quick-access-btn" @click="navigateTo('/reports')">
            <IconComponent name="List" />
            <span>All Reports</span>
          </button>
          
          <!--<button class="quick-access-btn" @click="navigateTo('/reports/designer')">
            <IconComponent name="Settings" />
            <span>Report Designer</span>
          </button>-->
        </div>
      </div>
      
      <div class="pl-3">
    <div class="overflow-y-auto h-full pb-20" style="max-height: calc(100vh - 200px);">
      <div 
        v-for="report in reports" 
        :key="report.uid"
        class="p-0 border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900"
      >
        <button
        @click="handleReportSelect(report.uid)"
        class="w-full px-2 py-2 flex text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
         {{ report.name }}
        </button>
      </div>
    </div>
      </div>
    </div>
  </div>
  <ReportViewer 
      :report-id="reportId"
      @row-expand="handleRowExpand"
      :show="showReport"
      @close="reportId = ''; showReport = false"
    />
</template>
<style scoped>
.quick-access-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 1.25rem;
}

.quick-access-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  background-color: white;
  transition: all 0.2s;
  cursor: pointer;
}

.quick-access-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-color: #1a5fb4;
}

.quick-access-btn i {
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
  color: #1a5fb4;
}

.quick-access-btn span {
  font-size: 0.875rem;
  color: #495057;
}
</style>